export default "__VITE_ASSET__mLXRobnZ__"